import React, {useCallback, useMemo, useState} from 'react';
import {classes, style} from './doppe-action-content-section-media-gallery.st.css';
import {listViewCreateDataSource, useObservableCalculatedValue} from '@wix/devzai-utils-react';
import {DoppeActionContentSection} from '../../../client-server-common/types/doppe-action-content-section';
import {
    DoppeActionLayout,
    doppeListActionSettingsFilterHiddenListItemsFromActionView
} from '../../../client-server-common';
import {
    DoppeActionTypeWidgetItemListCarousel
} from '../../../doppe-action-types/doppe-actions-common/doppe-action-type-widget-item-list/doppe-action-type-widget-item-list';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {
    DoppeActionTypeGalleryListViewItem
} from '../../../doppe-action-types/doppe-actions-common/doppe-action-type-list-view-item/doppe-action-type-gallery-list-view-item/doppe-action-type-gallery-list-view-item';
import {
    DoppeActionTypeMediaGalleryItemPreview
} from '../../../doppe-action-types/doppe-actions-common/doppe-action-type-media-gallery-item-preview/doppe-action-type-media-gallery-item-preview';
import {
    doppeViewerActionContextOpenModal
} from '../../../doppe-sdk/doppe-viewer-action-context/doppe-viewer-action-context-utils';
import {DoppeViewerModalPanelLayout} from '../../doppe-viewer-modal-panel/doppe-viewer-modal-panel';


export const DoppeActionContentSectionMediaGallery = React.memo(function DoppeActionContentSectionMediaGallery(
    props: DoppeActionContentSectionMediaGallery.Props
) {
    const {
        contentSection,
        actionContext
    } = props;

    const {
        listDataItems,
    } = contentSection;


    const itemsToShow = useMemo(() => {
            return doppeListActionSettingsFilterHiddenListItemsFromActionView(listDataItems)
        },
        [listDataItems]
    );

    const mediaGalleryItemsViewDataSource = useMemo(() => {
            return listViewCreateDataSource(itemsToShow, {
                idFunction: item => item.id
            })
        },
        [itemsToShow]
    );

    const [currentItem, setCurrentItem] = useState(itemsToShow[0]);

    const observableItem = useObservableCalculatedValue(useCallback(() => {
        return currentItem;
    }, [currentItem]));

    return <DoppeActionTypeWidgetItemListCarousel
        className={style(classes.root, {})}
        listClassName={style(classes.innerList, {})}
        layout={DoppeActionLayout.Carousel}
        onItemClick={listItem => {
            setCurrentItem(listItem);

            doppeViewerActionContextOpenModal(
                actionContext,
                (options) => {
                    return {
                        render: () =>
                            <DoppeActionTypeMediaGalleryItemPreview
                                galleryListItemsDataSource={mediaGalleryItemsViewDataSource}
                                currentItemId={listItem.id}
                                className={style(classes.galleryPreview, {})}
                                dismissButtonCallback={() => {
                                    options.modalController.closeWindow();
                                }}
                                listItemTemplateSectionsSettings={contentSection.listItemTemplateSectionsSettings}
                                listItemTemplateCtaButtonsSettings={contentSection.listItemTemplateCtaButtonsSettings}
                                actionContext={actionContext}
                                reportGoalAchieved={() => {}}
                            />,
                        dependencies: [observableItem]
                    }
                },
                {
                    mobileLayout: DoppeViewerModalPanelLayout.FullScreen,
                    desktopLayout: DoppeViewerModalPanelLayout.FullScreen,
                    showHeader: false
                }
            );
        }}
        renderItem={(dataItem, layout, index) => {
            return (
                <DoppeActionTypeGalleryListViewItem
                    innerItemId={dataItem.id}
                    innerItemIndex={index}
                    listItemSettings={dataItem}
                    layout={layout}
                    isOneItem={mediaGalleryItemsViewDataSource.length === 1}
                    hideTitleWhenPossible={false}
                    hideDescriptionWhenPossible={false}
                />
            )
        }}
        dataSourceItems={mediaGalleryItemsViewDataSource}
    />
});


export namespace DoppeActionContentSectionMediaGallery {

    export interface Props extends React.HTMLAttributes<any> {
        contentSection: DoppeActionContentSection.GallerySettings;
        actionContext: IDoppeViewerActionContext;
    }
}
